import axios from "axios";

// link : https://takafula.com/
// test: http://104.248.246.2:81/
//  https://takaful.sale/
export const usedUrl="https://takaful.sale/";

const baseURL=axios.create({baseURL:usedUrl});
 const loggedUser=JSON.parse(localStorage.getItem('user')); 
 let isAdmin=false;
 if(!loggedUser?._id) isAdmin=true

export const config={
    headers:{
        authorization:`${localStorage.getItem("token")}`,
        // is_admin: true
    }
};
export default baseURL;